import requestv2 from "~/utils/http-v2";

const dashboardApi = {
	saleCommit : async (params) => {
		const url = 'v2/dashboard/sale/commit';
		return await requestv2.get(url, {params});
	},
	salePoint : async (params) => {
		const url = 'v2/dashboard/sale/point';
		return await requestv2.get(url, {params});
	},
	saleKpi : async (params) => {
		const url = 'v2/dashboard/sale/kpi';
		return await requestv2.get(url, {params});
	},
	revenue : async (params) => {
		const url = 'v2/dashboard/revenue';
		return await requestv2.get(url, {params});
	},
	revenueRanks : async (params) => {
		const url = 'v2/dashboard/revenue/ranks';
		return await requestv2.get(url, {params});
	},
	revenueGroup : async (params) => {
		const url = 'v2/dashboard/revenue/group';
		return await requestv2.get(url, {params});
	},
	contractNew : async (params) => {
		const url = 'v2/dashboard/contract/new';
		return await requestv2.get(url, {params});
	},
	contractRanks : async (params) => {
		const url = 'v2/dashboard/contract/ranks';
		return await requestv2.get(url, {params});
	},
	customer : async (params) => {
		const url = 'v2/dashboard/customer';
		return await requestv2.get(url, {params});
	},
	customerGroup : async (params) => {
		const url = 'v2/dashboard/customer/group';
		return await requestv2.get(url, {params});
	},
	designProject : async (params) => {
		const url = 'v2/dashboard/design/project';
		return await requestv2.get(url, {params});
	},
	designRanks : async (params) => {
		const url = 'v2/dashboard/design/ranks';
		return await requestv2.get(url, {params});
	},
	personnelCount : async (params) => {
		const url = 'v2/dashboard/personnel/count';
		return await requestv2.get(url, {params});
	},
	personnelBirthday : async (params) => {
		const url = 'v2/dashboard/personnel/birthday';
		return await requestv2.get(url, {params});
	},
};

export default dashboardApi;